export default "__VITE_ASSET__CgHdY0q4__"